import { GoogleInitOptions } from '@abacritt/angularx-social-login';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '@shared/services/storage.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/langs/', '.json');
}

export function lottiePlayerFactory() {
  return import('lottie-web');
}

export function getGoogleLoginOptions(): GoogleInitOptions {
  const googleLoginOptions: GoogleInitOptions = {
    oneTapEnabled: localStorage.getItem(StorageService.SESSION_COOKIE) ? false : true,
  };
  return googleLoginOptions;
}
